import dayjs, { Dayjs } from 'dayjs'

import { isString } from '@app/typeGuards'
import { isEmptyString, isNullable } from '@app/utils'
import { dateFormat } from '@app/constants'

import type { ObjectValuesType } from '@app/types'

export interface GetFormattedDateOptions {
  extractionFormat?: string
}

export const getFormattedDate = (
  date: string | null | undefined | Dayjs,
  format: ObjectValuesType<typeof dateFormat>,
  options: GetFormattedDateOptions = {}
): string | null => {
  if (isNullable(date)) return null

  if (isString(date) && isEmptyString(date)) return null

  if (date instanceof dayjs && !isString(date)) return date.format(format)

  const { extractionFormat } = options

  return dayjs(date, extractionFormat).format(format)
}
